// used for page-load and page-segment-load events
export const FF_ALLOWLIST_FOR_PERF_METRICS = [
	'confluence.ssr.page-statuses',
	'analytics-next-use-modern-context_jira',
	'confluence_ssr_enable_tesseract_stream_endpoint',
	'confluence_use_canary',
	'confluence_use_parcel',
	'confluence_frontend_use_modern_rendering_engine',
	'confluence_ssr_load_after_paint_loadables_as_paint',
	'ssr_end_of_page_recommendation',
	'confluence_ssr_enable_hydration',
	'confluence_react_streaming',
	'confluence_ssr_enable_hydration_home',
	'confluence_preload_forge_viewport_heights',
	'confluence_frontend_vc_observer_initialization',
	'platform_fix_banner_spacer_vc',
	'platform_fix_media_image_resizing',
	'confluence_frontend_preload_edit_and_analytics',
	'platform_exclude_media_offender_from_vc',
	'confluence_ssr_enable_hydration_space_overview',
	'confluence_frontend_remove_comments_placeholder',
	'enable_loadable_placeholder_for_legacy_macros',
	'confluence_frontend_remove_eop_initial_animation',
	'confluence_frontend_cache_pagetree_reference',
	'confluence_frontend_tree_create_popover_offset',
	'confluence_frontend_memoize_content_tree_rendering',
	'edition_awareness_standard_upsell_confluence_ab',
	'edition_awareness_standard_upsell_confluence_ab_fg',
	'platform_exclude_media_single_from_vc',
	'confluence_frontend_content_body_container',
	'platform-ssr-table-resize',
	'confluence_ssr_permissions_error_handler',
	'confluence_frontend_show_breadcrumbs_initial_load',
	'platform_hide_heading_anchor_wrapper_before_hover',
	'team-bi-directional-container-connection',
	'confluence_frontend_ssr_autohighlights',
	'cc_search_input_open_press_tracing',
	'cc_ignore_placeholder_legacy_profile_wrapper',
	'cc_fix_spaceoverview_macro_preload',
	'cc_fix_macro_resource_ssr',
	'confluence_frontend_exclude_excerpt_macro_vc',
];

// In order to reduce BM event payload size, include a FF in the BM payload only if it's in the allow list.
// The following FFs will be included in all types of BM event.
export const ALLOWLIST_FFS_CUSTOM_EVENTS = [];
